import { FormattedMessage } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'

function TourAsiaCampaignHeroCarouselSubtitle() {
  return <BodyText variant="medium" colour="normal-contrast"><FormattedMessage
    id="z8bMXXmEx7hpONfBxrm4"
    defaultMessage="Use code TOURASIA5 for up to $1,550 off select departures. Limited time only!"
    description="Promotional savings message for tour Asia campaign hero carousel"
  />
  </BodyText>
}

export default TourAsiaCampaignHeroCarouselSubtitle
